module.exports = __webpack_public_path__ + "img/doc.7fdea0ea.png";